export default "__VITE_ASSET__CFhgDebx__"